export type ClientLogo = {
  name: string;
  src: string;
};

export const clientLogos: ClientLogo[] = [
  { name: 'American Express', src: 'https://cdn.magicpatterns.com/uploads/xANVQxZqudSNrt8vPvnhfw/Amex_1.svg' },
  { name: 'BCG', src: 'https://cdn.magicpatterns.com/uploads/a2uQujuMqE47SJKLc8HuJ9/BCG_1.svg' },
  { name: 'Chase', src: 'https://cdn.magicpatterns.com/uploads/eVvwGBhFDWmUDC43xk96Ao/Chase_1.svg' },
  { name: 'DrFirst', src: 'https://cdn.magicpatterns.com/uploads/fJDdjBe77oDCaf3zPpUzpv/DrFirst_1.svg' },
  { name: 'McKinsey & Company', src: 'https://cdn.magicpatterns.com/uploads/fn1Tq2hRyq7rLiDHyxpFpq/McKinsey_1.svg' },
  { name: 'PubMatic', src: 'https://cdn.magicpatterns.com/uploads/cKnvC8Qexu82cntQ1g5BJz/Pubmatic_1.svg' },
];
